import React, {useState, useEffect,useMemo} from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import '../styles/global.css';
import axios from 'axios';
import Tooltip from '@mui/material/Tooltip';
import { CircularProgress } from '@mui/material';
import ForwardToInboxTwoToneIcon from '@mui/icons-material/ForwardToInboxTwoTone';
import PermIdentityTwoToneIcon from '@mui/icons-material/PermIdentityTwoTone';
import PersonOffTwoToneIcon from '@mui/icons-material/PersonOffTwoTone';
import MenuAssociados from "../components/MenuAssociados";

function MapaAnual() {
    const {idPessoa} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const loggedIn = sessionStorage.getItem('loggedIn');
    const [dadosMapaAnual, setDadosMapaAnual] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    //const [anoAtual, setAnoAtual] = useState(new Date().getFullYear());
    const [anoAtual, setAnoAtual] = useState(sessionStorage.anoMensalidade ? sessionStorage.anoMensalidade : new Date().getFullYear());
    const [menuAberto, setMenuAberto] = useState(false);
    const navigate = useNavigate();
    const [yearsSelect, setYearsSelect] = useState([]);

    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    useEffect(() =>{
        if (idPessoa 
            && parseInt(idPessoa) !== 0 
            && parseInt(idPessoa) !== parseInt(sessionStorage.getItem('IdPessoa'))) {
            navigate('/Login');
            window.location.reload();
        }
    },[]);
    
    // Gerar os anos para o select, começando do ano atual e retrocedendo até 2021
    const years = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const startYear = 2021;
        const yearsArray = [];

        //yearsArray.push('TODOS'); // Opção para todos os anos
        // Adiciona o ano atual e retrocede até 5 anos ou o limite de 2021
        for (let i = 0; i <= 30; i++) {
        const year = currentYear - i;
        if (year >= startYear) {
            yearsArray.push(year);
        } else {
            break; // Para o loop se for menor que 2021
        }
        }
        return yearsArray;
    }, []); // Executa apenas uma vez
    
    //açao para setar o ano selecionado no select para exibição da lista por mês
    function handleSelectAno(event) {
        sessionStorage.anoMensalidade = event.target.value
        setAnoAtual(sessionStorage.anoMensalidade)
        handleCarregarAno(sessionStorage.anoMensalidade);
    }
    const [selectStatus, setSelectStatus] = useState('');
    function handleSelectStatusRegistro(event) {
        sessionStorage.selectStatusRegistro = event.target.value
        setSelectStatus(sessionStorage.selectStatusRegistro)
    }

    useEffect(() => {
        setYearsSelect(years);
        setAnoAtual(years[0]);
    }, [years]);

    useEffect(() => {
        setIsLoading(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const dados = {
            "mslAno": anoAtual,
            "idPessoa": idPessoa
        }
        axios.post(process.env.REACT_APP_API_URL + 
            "/routes.php?metodo=obtemMapaDeMensalidades",
            dados,
            {
                headers: {
                    "X-Access-Token": token,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data);
            setDadosMapaAnual(response.data);
            setIsLoading(false);
        })
        .catch(error => {
            console.error('Erro ao carregar o mapa anual de mensalidades:', error);
            setIsLoading(false);
        });
    }
    , [anoAtual]);
    //carrega o mapa anual de mensalidades
    function handleCarregarAno(ano) {
        //console.log(ano); return;
        setIsLoading(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const dados = {
            "mslAno": ano,
            "idPessoa": idPessoa
        }
        axios.post(process.env.REACT_APP_API_URL + 
            "/routes.php?metodo=obtemMapaDeMensalidades",
            dados,
            {
                headers: {
                    "X-Access-Token": token,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            setDadosMapaAnual(response.data);
            setIsLoading(false);
        })
        .catch(error => {
            console.error('Erro ao carregar o mapa anual de mensalidades:', error);
            setIsLoading(false);
        });
    }

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const [modeloEmailResumo, setModeloEmailResumo] = useState("");

    useEffect(() => {
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        axios.post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemModeloEmailPorDescricao',
            {
                emlDescricao: 'ResumoDeMensalidades'
            }, 
            {
                headers: 
                {
                    "X-Access-Token" : token,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            setModeloEmailResumo(response.data);
        })
        .catch(error => {
            console.error('Erro ao obter o modelo de email:', error);
        });
    }, []);


    async function handleEnviarResumo(item) {
        setIsLoading(true);
        await delay(2000);
        
        sessionStorage.setItem('mapaClicadoId', item.IdPessoa);

        var corpoEmail = modeloEmailResumo.emlCorpo;
        //console.log(corpoEmail);
        //console.log(item);
        try {
            if (item.pesEmail !== '' && item.pesEmail !== undefined && corpoEmail)
            {
                var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
                corpoEmail = '<div style="padding: 20px; font-size: 14px;">' + corpoEmail + '</div>';
                let detalhamento = 
                `<span style="font-weight: 600;">
                    <ul>
                        <li style="color: ${item.JAN == 1 ? 'green' : 'red'};">Janeiro: ${item.JAN == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.FEV == 1 ? 'green' : 'red'};">Fevereiro: ${item.FEV == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.MAR == 1 ? 'green' : 'red'};">Março: ${item.MAR == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.ABR == 1 ? 'green' : 'red'};">Abril: ${item.ABR == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.MAI == 1 ? 'green' : 'red'};">Maio: ${item.MAI == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.JUN == 1 ? 'green' : 'red'};">Junho: ${item.JUN == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.JUL == 1 ? 'green' : 'red'};">Julho: ${item.JUL == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.AGO == 1 ? 'green' : 'red'};">Agosto: ${item.AGO == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.SET == 1 ? 'green' : 'red'};">Setembro: ${item.SET == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.OUT == 1 ? 'green' : 'red'};">Outubro: ${item.OUT == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.NOV == 1 ? 'green' : 'red'};">Novembro: ${item.NOV == 1 ? 'Pago' : 'Pendente'}</li>
                        <li style="color: ${item.DEZ == 1 ? 'green' : 'red'};">Dezembro: ${item.DEZ == 1 ? 'Pago' : 'Pendente'}</li>
                    </ul>
                </span>`;

                corpoEmail = '<img src="https://www.brasilextremos.com.br/logo512.png" alt="Logo Brasil Extremos" width="200" /><br />' + corpoEmail;
                corpoEmail = corpoEmail
                    .replace('[anoAtual]',`${anoAtual}`)
                    .replace('[nomeAssociado]',`${item.ASSOCIADO}`)
                    .replace('[anoAtual]',`${anoAtual}`)
                    .replace('[dataAssociacao]',`${item.pesCriadoEm?.substring(0,10)}`)
                    .replace('[detalhamento]',`${detalhamento}`);

                //modelo de email para envio do resumo de mensalidades
                // corpoEmail = `
                // <div style="margin-left: 20px;">
                // <img src="https://www.brasilextremos.com.br/logo512.png" alt="Logo Brasil Extremos" width="200" />
                //     <h2>Resumo de Mensalidades - ${anoAtual}</h2>
                //     <p></p>
                //     <h3>** LEIA ATENTAMENTE **</h3>
                //     <p></p>
                //     <div style="margin-top: 20px; font-family: Arial, sans-serif; font-size: 1.1em;">
                //     <p>Prezado(a) ${item.ASSOCIADO}, seguimos com nosso compromisso de mantê-lo informado sobre suas mensalidades.</p>
                //     <hr />
                //     <p><b>AVISO IMPORTANTE:</b></p>
                //     <p><b>É fundamental que você verifique atentamente o status de cada mensalidade.</b></p>
                //     <p><b>Manter suas mensalidades em dia é essencial para o bom funcionamento da associação.</b></p>
                //     <p><b>O não pagamento desse compormisso financeiro pode resultar em dificuldades na associação,</b></p>
                //     <p><b>comprometendo as obrigações financeiras, como custear a sede</b></p>
                //     <p><b>e outras despesas essenciais para o bom funcionamento da associação.</b></p>
                //     <p><b>Bem como oferecer vantagens aos membros assíduos em eventos promovidos pela associação.</b></p>
                //     <p><b>Portanto, é de extrema importância manter suas mensalidades em dia.</b></p>
                //     <p><b>Agradecemos sua atenção e colaboração.</b></p>
                //     <br/>
                //     <p><b>Em casos de dificuldades com o pagamento das mensalidades, entre em contato com a Tesouraria para orientação.</b></p>
                //     <p><b>Estamos à disposição para auxiliar em qualquer situação relacionada às mensalidades.</b></p>
                //     <hr />
                //     <p>Segue o resumo das mensalidades do ano de ${anoAtual}:</p>
                //     <p><b>Observação:</b> Este resumo é gerado automaticamente com base nos registros de pagamento disponíveis.</p>
                //     <p>Se houver alguma divergência ou dúvida, por favor, entre em contato com a Tesouraria.</p>
                //     <p>Tendo recibos ou comprovantes de pagamento, envie-os para o e-mail mgbrasilextremos@gmail.com,</p> 
                //     <p>ou envie pelo WhatsApp da Associação, para que possamos atualizar os registros.</p>
                //     <hr />
                //     <p style="font-weight: 700; color: orange;">* O mês <b>atual</b> sempre é fechado no início do próximo,</p> 
                //     <p style="font-weight: 700; color: orange;">  então se você já acertou a mensalidade antes do fechamento,</p> 
                //     <p style="font-weight: 700; color: orange;">  ela será atualizada como "Pago" no próximo fechamento.</p>
                //     <hr />
                //     <p style="font-weight: 700; color: orange;">* Sua data de associação é: ${item.pesCriadoEm?.substring(0,10)},</p>
                //     <p style="font-weight: 700; color: orange;">  desconsidere pendências sinalizadas anteriores a essa data.</p>
                //     <hr />
                //     </div>
                //     <span style="font-weight: 600;">
                //         <p>Segue abaixo o detalhamento:</p>
                //         <ul>
                //             <li style="color: ${item.JAN == 1 ? 'green' : 'red'};">Janeiro: ${item.JAN == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.FEV == 1 ? 'green' : 'red'};">Fevereiro: ${item.FEV == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.MAR == 1 ? 'green' : 'red'};">Março: ${item.MAR == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.ABR == 1 ? 'green' : 'red'};">Abril: ${item.ABR == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.MAI == 1 ? 'green' : 'red'};">Maio: ${item.MAI == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.JUN == 1 ? 'green' : 'red'};">Junho: ${item.JUN == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.JUL == 1 ? 'green' : 'red'};">Julho: ${item.JUL == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.AGO == 1 ? 'green' : 'red'};">Agosto: ${item.AGO == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.SET == 1 ? 'green' : 'red'};">Setembro: ${item.SET == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.OUT == 1 ? 'green' : 'red'};">Outubro: ${item.OUT == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.NOV == 1 ? 'green' : 'red'};">Novembro: ${item.NOV == 1 ? 'Pago' : 'Pendente'}</li>
                //             <li style="color: ${item.DEZ == 1 ? 'green' : 'red'};">Dezembro: ${item.DEZ == 1 ? 'Pago' : 'Pendente'}</li>
                //         </ul>
                //     </span>
                //     <br />
                //     <p>Atenciosamente,</p>
                //     <p style="font-weight: 600;">Tesouraria MG Brasil Extremos</p>
                //     <hr />
                //     <div style="font-size: 12px; color: gray;">
                //         O conteúdo desse e-mail é confidencial e destinado apenas ao destinatário.<br />
                //         Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                //         A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                //         Agradecemos sua compreensão e cooperação.<br />
                //         <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                //     </div>
                // </div>
                // `;
                //console.log(corpoEmail);
                //envia o email para o associado
                const dados = {
                    "email": item.pesEmail,
                    "assunto": `Resumo de Mensalidades - ${anoAtual}`,
                    "mensagem": corpoEmail
                }
                setIsLoading(true);
                axios.post(process.env.REACT_APP_API_URL +
                    "/routes.php?metodo=enviarEmail",
                    dados,
                    {
                        headers: {
                            "X-Access-Token": token,
                            "Content-Type": "application/json; charset=UTF-8"
                        }
                    }
                )
                .then(response => {
                    //console.log(response.data);
                    alert(`Resumo de mensalidades enviado para ${item.pesEmail}`);
                    const log = {
                        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
                        logTipo: "Envio de Email",
                        logModulo: `Mapa Anual de Mensalidades - ${anoAtual} - para ${item.pesEmail}`,
                        //logDescricao: `Resumo de mensalidades enviado para ${item.pesEmail}`,
                        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
                        logCriadoEm: new Date().toISOString(),
                        logCodigoGUID: crypto.randomUUID()
                    };
                    axios                    
                    .post(process.env.REACT_APP_API_URL 
                        + '/routes.php?metodo=novoLog', 
                        log, {
                            headers: {
                                "X-Access-Token" : token,
                                "Content-Type": "application/json; charset=UTF-8"
                            }
                        }
                    )
                    .then(response => {
                        //console.log(response.data[0].mensagem);
                    })
                    .catch(error => {
                        console.error('Erro ao enviar log:', error);
                    });
                    
                    setIsLoading(false);
                    scrollToClickedItem();
                })
                .catch(error => {
                    console.error('Erro ao enviar o resumo de mensalidades:', error);
                    alert(`Erro ao enviar o resumo de mensalidades para ${item.pesEmail}`);
                    setIsLoading(false);
                });
            }
        }
        catch (error) {
            console.error('Erro ao processar o envio de email:', error);
            alert(`Erro ao processar o envio de email para ${item.pesEmail}`);
            setIsLoading(false);
        }
        
    }

    function handleEditarPessoa(item){
        //console.log(item);
        sessionStorage.setItem('mapaClicadoId', item.IdPessoa);
        setIsLoading(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        //obtem o cadastro da pessoa e se tiver retorno encaminha os dados dela para edição.
        const dados = {
            IdPessoa: parseInt(item.IdPessoa),
            pesEmail: "",
            pesCodigoGUID: "",
            associado: 1
        }
        axios
        .post(process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=obtemCadastroAssociado',
            dados,
            { headers:
                {
                    "X-Access-Token" : token,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            if(response.data){
                sessionStorage.setItem('origemEditarPessoa', 'Mapa');
                navigate(`/Cadastro`, { state: { cadastro: response.data } });
            }
            //console.log(response);
        })
        .catch(error => {
            console.log(error);
        })

        //console.log(dados);

        setIsLoading(false);
    }
    //console.log(dadosMapaAnual);

    //vai para linha de foco após edição
    useEffect(() => {
        scrollToClickedItem();
    }, [dadosMapaAnual]);

    function scrollToClickedItem() {
        const itemClicadoId = sessionStorage.getItem('mapaClicadoId');
    
        if (itemClicadoId) {
          const elementoLinha = document.getElementById(`mapa-${itemClicadoId}`);
          
          if (elementoLinha) {
            // Rola até a linha clicada de forma suave
            setTimeout(() => {
              elementoLinha.scrollIntoView({ behavior: 'smooth', block: 'center' });
              // Destaque visual temporário opcional (ex: piscar a linha)
              elementoLinha.style.backgroundColor = '#fff9c4'; 
              setTimeout(() => elementoLinha.style.backgroundColor = '', 3000);
            }, 100); // Um pequeno delay garante que o HTML já renderizou
    
            // 2. Limpa o ID para não rolar de novo se o usuário atualizar a página (F5)
            sessionStorage.removeItem('mapaClicadoId');
          }
        }
    }

    //salvar log de navegação
    const [salvarLog, setSalvarLog] = useState(true);
    useEffect(() => {
        if (salvarLog === false) return;
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "Navegação",
        logModulo: "Mapa Anual de Mensalidades",
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data[0].mensagem);
            setSalvarLog(false);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
            setSalvarLog(false);
        })
        .finally(() => {
            setSalvarLog(false);
        });
        
    }, []);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* Menu de Naavegação */}
                    <div>
                        <MenuAssociados />
                    </div>
                    {/* Titulos da página */}
                    <div className="headerMain">
                        <label className='labelTitulo' >FINANCEIRO</label>
                        <label className='labelSubTitulo'>Mapa Anual de Mensalidades</label>
                    </div>
                    {/* Barra de pesquisa */}
                    <div className="containerBarraPesquisa">
                        <input className="inputBarraPesquisa"
                            placeholder="PESQUISAR"
                            type="text"
                            id="inputPesquisa"
                            name="inputPesquisa"
                            onChange={event => {
                                setSearchTerm(event.target.value)
                            }}
                            style={{ display: parseInt(sessionStorage.pesAdmin) === 1 ? 'block' : 'none' }}
                        />

                        <select className="selectStatusPesquisa"
                            name="selectAnoMensalidade"
                            id="selectAnoMensalidade"
                            onChange={event => {
                                handleSelectAno(event);
                            }}
                        >
                            {yearsSelect.map((year) => (
                                <option key={year} value={year} selected={parseInt(anoAtual) === year}>{year}</option>
                            ))}
                            
                        </select>

                        <select className="selectStatusPesquisa"
                            name="selectStatusRegistro"
                            id="selectStatusRegistro"
                            selected={sessionStorage.selectStatusRegistro !== undefined ? sessionStorage.selectStatusRegistro : '99'}
                            onChange={event => {
                                handleSelectStatusRegistro(event);
                            }}
                        >
                            <option value="99" selected={sessionStorage.selectStatusRegistro === '99'}>TODOS</option>
                            <option value="1" selected={sessionStorage.selectStatusRegistro === '1'}>ATIVOS</option>
                            <option value="0" selected={sessionStorage.selectStatusRegistro === '0'}>INATIVOS</option>
                        </select>

                        {/* <Link to={`/Mensalidades`}>  */}
                            <button className="buttonModalPadrao" onClick={() => navigate(-1)}>
                                VOLTAR
                            </button>
                        {/* </Link> */}

                    </div>
                </div>

                {/* Conteúdo principal */}
                <div className="tabelaPadrao">
                    <table className="tabelaDados">
                        <thead>
                            <tr>
                                <th>Associado</th>
                                <th>JAN</th>
                                <th>FEV</th>
                                <th>MAR</th>
                                <th>ABR</th>
                                <th>MAI</th>
                                <th>JUN</th>
                                <th>JUL</th>
                                <th>AGO</th>
                                <th>SET</th>
                                <th>OUT</th>
                                <th>NOV</th>
                                <th>DEZ</th>
                                {parseInt(sessionStorage.pesAdmin) === 1 && 
                                <th>AÇÕES</th>
                                }
                            </tr>
                        </thead>
                        <tbody id="corpoTabelaMapaAnual">
                            {/* Os dados da tabela serão inseridos aqui dinamicamente */}
                            {isLoading ? (
                                <tr>
                                    <td colSpan="13" style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                            ) : (
                                dadosMapaAnual && 
                                dadosMapaAnual
                                .filter(val => {
                                    if(searchTerm === '') {
                                        if(sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro === '99')
                                        {
                                            return val
                                        }
                                        else if (sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro !== '99')
                                        {
                                            if(parseInt(sessionStorage.selectStatusRegistro) === parseInt(val.ASSOCIADO_STATUS))
                                            {
                                                return val
                                            }
                                        }
                                        else{
                                            return val
                                        }
                                    } else if (val.ASSOCIADO
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())) 
                                        {
                                            if(sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro === '99')
                                            {
                                                return val
                                            }
                                                else if (sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro !== '99')
                                            {
                                                if(parseInt(sessionStorage.selectStatusRegistro) === parseInt(val.ASSOCIADO_STATUS))
                                                {
                                                    return val
                                                }
                                            }
                                            else{
                                                return val
                                            }
                                        }
                                    return null;
                                })
                                .map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.ASSOCIADO}</td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.JAN == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.JAN == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.JAN == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.FEV == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.FEV == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.FEV == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.MAR == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.MAR == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.MAR == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.ABR == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.ABR == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.ABR == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.MAI == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.MAI == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.MAI == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.JUN == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.JUN == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.JUN == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.JUL == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.JUL == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.JUL == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.AGO == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.AGO == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.AGO == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.SET == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.SET == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.SET == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.OUT == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.OUT == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.OUT == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.NOV == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.NOV == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.NOV == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        <td>
                                            <div  style={{
                                                padding: '5px',  
                                                textAlign: 'center', 
                                                backgroundColor: item.DEZ == 1 ? 'green' : 'orange', 
                                                borderRadius: '5px',
                                                color: item.DEZ == 1 ? 'white' : 'red', 
                                                fontWeight: 'bold',
                                                }}>
                                                {item.DEZ == 1 ? 'PG' : 'PD'}
                                            </div>
                                        </td>
                                        {parseInt(sessionStorage.pesAdmin) === 1 && (
                                            isLoading ? (
                                                <td colSpan="12" style={{ textAlign: 'center' }}>
                                                    <CircularProgress />
                                                </td>
                                            ) : (
                                            <td>
                                                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexDirection: 'row' }}>
                                                    <div>
                                                        <Tooltip title={parseInt(item.pesStatus) === 1 ? 'Ativo - Editar Cadastro' : 'Inativo - Editar Cadastro'}>
                                                            <button id={`mapa-${item.IdPessoa}`} 
                                                                onClick={() => handleEditarPessoa(item)}
                                                                style={{ cursor: 'pointer', borderRadius: '4px' }}
                                                                >
                                                                {parseInt(item.pesStatus) === 1 ? <PermIdentityTwoToneIcon /> : <PersonOffTwoToneIcon />}
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                    <div>
                                                        <Tooltip title="Enviar resumo por e-mail">
                                                            <button id={`mapa-${item.IdPessoa}`} 
                                                                onClick={() => handleEnviarResumo(item)} 
                                                                style={{ cursor: 'pointer', borderRadius: '4px' }}
                                                                >
                                                                <ForwardToInboxTwoToneIcon />
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                    {isLoading && <p>Carregando dados...</p>}
                </div>
            </main>
        </div>
    );
}

export default MapaAnual;